module.exports = __webpack_public_path__ + "img/thumbnail-autumn.1b27ab86.jpg";